var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-list-wrapper" }, [
    _c(
      "div",
      { staticClass: "list-wrapper" },
      _vm._l(_vm.accountList, function(account, i) {
        return _c("account-item", {
          key: i,
          attrs: { clickAccount: _vm.clickAccount, account: account }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }